import { render, staticRenderFns } from "./ShopApp.vue?vue&type=template&id=db0ceffe&"
import script from "./ShopApp.vue?vue&type=script&lang=js&"
export * from "./ShopApp.vue?vue&type=script&lang=js&"
import style0 from "./ShopApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db0ceffe')) {
      api.createRecord('db0ceffe', component.options)
    } else {
      api.reload('db0ceffe', component.options)
    }
    module.hot.accept("./ShopApp.vue?vue&type=template&id=db0ceffe&", function () {
      api.rerender('db0ceffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shopApp/ShopApp.vue"
export default component.exports